import * as z from "zod";

export const bulkAdvanceWorkOrders = {
  name: "bulkAdvanceWorkOrders" as const,
  input: z.object({
    workOrderIds: z.array(z.string()),
    fromStepId: z.string().nullish(),
  }),
  output: z.object({ advancedCount: z.number(), failedCount: z.number() }),
};
